var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7347_1093)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7347_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 7.87509H13.2966C10.3071 7.87509 7.875 10.3036 7.875 13.2884V22.0777C7.875 25.0626 10.3071 27.491 13.2966 27.491H22.0996C25.0893 27.491 27.5214 25.0625 27.5214 22.0777V13.2884C27.5215 10.3036 25.0893 7.87509 22.0996 7.87509ZM25.7784 22.0777C25.7784 24.103 24.1281 25.7506 22.0997 25.7506H13.2966C11.2683 25.7507 9.61813 24.103 9.61813 22.0777V13.2884C9.61813 11.2632 11.2683 9.61551 13.2966 9.61551H22.0996C24.128 9.61551 25.7783 11.2632 25.7783 13.2884V22.0777H25.7784Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6981 12.6288C14.9067 12.6288 12.6357 14.8962 12.6357 17.6833C12.6357 20.4703 14.9067 22.7376 17.6981 22.7376C20.4896 22.7376 22.7605 20.4703 22.7605 17.6833C22.7605 14.8962 20.4896 12.6288 17.6981 12.6288ZM17.6981 20.9971C15.868 20.9971 14.3789 19.5105 14.3789 17.6832C14.3789 15.8558 15.8678 14.3691 17.6981 14.3691C19.5284 14.3691 21.0174 15.8558 21.0174 17.6832C21.0174 19.5105 19.5283 20.9971 17.6981 20.9971Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9729 11.1531C22.637 11.1531 22.3071 11.2889 22.0699 11.5267C21.8316 11.7634 21.6946 12.0929 21.6946 12.4294C21.6946 12.7648 21.8317 13.0943 22.0699 13.3321C22.307 13.5688 22.637 13.7057 22.9729 13.7057C23.3099 13.7057 23.6387 13.5688 23.877 13.3321C24.1152 13.0943 24.2512 12.7647 24.2512 12.4294C24.2512 12.0929 24.1152 11.7634 23.877 11.5267C23.6399 11.2889 23.3099 11.1531 22.9729 11.1531Z",
    fill: "#303030"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 16.5,
    stroke: "#303030",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7347_1093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7347_1093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6465,
    height: 19.616,
    fill: "white",
    transform: "translate(7.875 7.87509)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.be789b343b82177dc44756ffa4283691.svg";
export { ForwardRef as ReactComponent };